import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const firmTypeColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'firmType',
  headerName: 'Firm Type',
  initialHide: true,
};
